import {Component} from '@angular/core';

@Component({
    selector: 'app-base',
    template: `
        <div>
            base works!!
        </div>
    `
})
export class BaseComponent {

    constructor() {
    }
}
